export default __webpack_public_path__ + "images/4725336bfa1d40d5366871df42720563-acima-logo.svg";